import { useEffect, useState } from 'react'
import { Organization } from '../../models'
import { getLabOrganizations } from '../../../../services/LmsService'

export const useLabOrganizations = () => {
  const [organizations, setOrganizations] = useState<Organization[]>([])
  const fetchLab = async () => {
    const response = await getLabOrganizations()
    if (response?.success) {
      setOrganizations(response?.data?.organization || [])
    } else {
      setOrganizations([])
    }
  }
  useEffect(() => {
    fetchLab()
  }, [])

  return organizations
}
